var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalParticipantsGradientImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 80,
    viewBox: "0 0 250 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_8479_39961",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.6652 9H242.308C246.556 9 250 12.444 250 16.6923V62.8462C250 67.0945 246.556 70.5385 242.308 70.5385H79.2202C72.2504 76.4408 63.2333 80 53.3848 80C43.5363 80 34.5191 76.4408 27.5493 70.5385H7.69231C3.44396 70.5385 0 67.0945 0 62.8462V16.6923C0 12.444 3.44396 9 7.69231 9H28.1044C34.9947 3.37418 43.7957 0 53.3848 0C62.9738 0 71.7748 3.37418 78.6652 9Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.6652 9H242.308C246.556 9 250 12.444 250 16.6923V62.8462C250 67.0945 246.556 70.5385 242.308 70.5385H79.2202C72.2504 76.4408 63.2333 80 53.3848 80C43.5363 80 34.5191 76.4408 27.5493 70.5385H7.69231C3.44396 70.5385 0 67.0945 0 62.8462V16.6923C0 12.444 3.44396 9 7.69231 9H28.1044C34.9947 3.37418 43.7957 0 53.3848 0C62.9738 0 71.7748 3.37418 78.6652 9Z",
    fill: "url(#paint0_linear_8479_39961)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6652 9L78.0327 9.7746L78.3088 10H78.6652V9ZM79.2202 70.5385V69.5385H78.8537L78.574 69.7753L79.2202 70.5385ZM27.5493 70.5385L28.1956 69.7753L27.9159 69.5385H27.5493V70.5385ZM28.1044 9V10H28.4607L28.7368 9.7746L28.1044 9ZM78.6652 9V10H242.308V9V8H78.6652V9ZM242.308 9V10C246.004 10 249 12.9962 249 16.6923H250H251C251 11.8917 247.108 8 242.308 8V9ZM250 16.6923H249V62.8462H250H251V16.6923H250ZM250 62.8462H249C249 66.5422 246.004 69.5385 242.308 69.5385V70.5385V71.5385C247.108 71.5385 251 67.6468 251 62.8462H250ZM242.308 70.5385V69.5385H79.2202V70.5385V71.5385H242.308V70.5385ZM79.2202 70.5385L78.574 69.7753C71.778 75.5305 62.9879 79 53.3848 79V80V81C63.4787 81 72.7229 77.3511 79.8664 71.3016L79.2202 70.5385ZM53.3848 80V79C43.7817 79 34.9915 75.5305 28.1956 69.7753L27.5493 70.5385L26.9031 71.3016C34.0467 77.3511 43.2909 81 53.3848 81V80ZM27.5493 70.5385V69.5385H7.69231V70.5385V71.5385H27.5493V70.5385ZM7.69231 70.5385V69.5385C3.99625 69.5385 1 66.5422 1 62.8462H0H-1C-1 67.6468 2.89168 71.5385 7.69231 71.5385V70.5385ZM0 62.8462H1V16.6923H0H-1V62.8462H0ZM0 16.6923H1C1 12.9962 3.99625 10 7.69231 10V9V8C2.89168 8 -1 11.8917 -1 16.6923H0ZM7.69231 9V10H28.1044V9V8H7.69231V9ZM28.1044 9L28.7368 9.7746C35.4552 4.28921 44.0345 1 53.3848 1V0V-1C43.5569 -1 34.5343 2.45915 27.4719 8.2254L28.1044 9ZM53.3848 0V1C62.735 1 71.3143 4.28921 78.0327 9.7746L78.6652 9L79.2976 8.2254C72.2353 2.45915 63.2126 -1 53.3848 -1V0Z",
    fill: "black",
    fillOpacity: 0.05,
    mask: "url(#path-1-inside-1_8479_39961)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8479_39961",
    x1: 0,
    y1: 40,
    x2: 250,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F445E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239CE1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalParticipantsGradientImg);
export default __webpack_public_path__ + "static/media/total_participants_gradient_img.9a7b6f74847a87762f7da3f811aa9e21.svg";
export { ForwardRef as ReactComponent };